export const SERVICE = "admin/service";
export const FAQ = "admin/faq";

export const LEGAL = "admin/legal-info";
export const RESOURCES = "admin/resources";
export const FILEUPLAOD = "admin/upload";

export const ADDEDUCATION = "admin/education";

export const PRIVACYPOLICY = "admin/privacy-policy";


export const TERMSCONDITIONS = "admin/terms-conditions";

export const ABOUT = "admin/about";

export const PROMOTION = "admin/promotion";

export const SEARCH = "admin/search";

export const CASEREFERAL = "admin/case-referral";

 
export const APPOINTMENTSREFERAL = "admin/appointment";



export const DASHBOARDS_STATS = "admin/appointment/reports/statistics";
export const DASHBOARDS_PEAK = "admin/appointment/reports/peak-periods";


export const SUBADMIN = "admin/sub-admin";